const FILTER_CLICK_EVENT = 'filter:click';

export const dispatchFilterClickEvent = () => {
  dispatchEvent(new CustomEvent(FILTER_CLICK_EVENT));
};
